module.exports = new __parcel__URL__("icon-contact.2aab738b.svg").toString();